import { render } from "./Modal.vue?vue&type=template&id=71f72711&ts=true"
import script from "./Modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Modal.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/Modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71f72711"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71f72711', __exports__)) {
    api.reload('71f72711', __exports__)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=71f72711&ts=true", () => {
    api.rerender('71f72711', render)
  })

}


export default __exports__